'use strict'
import {Margin} from './margin'

export class AttributionChart {
  constructor(d3, selector) {
    this._d3 = d3
    this.container = this._d3.select(selector)
    this.line = this._d3.svg.line().interpolate('monotone')

    this.x = this._d3.scale.linear()
    this.y = this._d3.scale.linear()
    this.xAxisScale = this._d3.svg.axis()
    this.yAxisScale = this._d3.svg.axis()

    this.svg = this.container.append('svg')
    this.chart = this.svg.append('g')
    this.xAxis = this.chart.append('g').attr('class', 'x axis')
    this.yAxis = this.chart.append('g').attr('class', 'y axis')

    this.visitTypes = this._d3.scale.ordinal()
    .domain([0, 1])
    .range(['line--control', 'line--exposed'])

    this.calibrateChartDimensions()
    window.onresize = this.calibrateChartDimensions.bind(this)
  }
  calibrateChartDimensions() {
    const margin = new Margin(this.container.node())
    const width = margin.width
    const height = margin.height

    this.x
    .range([0, width])

    this.y
    .range([height, 0])

    this.xAxisScale
    .scale(this.x)
    .tickPadding(20)
    .tickFormat(d => `DAY ${d}`)
    .orient('bottom')

    this.yAxisScale
    .scale(this.y)
    .tickSize(width)
    .tickFormat(this._d3.format('.2%'))
    .orient('left')

    this.line
    .x(d => this.x(d.day))
    .y(d => this.y(d.rate))

    this.svg
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)

    this.chart
    .attr('transform', `translate(${margin.left}, ${margin.top})`)

    this.xAxis
    .attr('transform', `translate(0, ${height})`)
    .call(this.xAxisScale)

    this.yAxis
    .attr('transform', `translate(${width})`)
    .call(this.yAxisScale)

    this.chart.selectAll('.line')
      .attr('d', d => this.line(d))
  }
  renderChart(campaign) {
    const allVisits = [campaign.control_visits, campaign.exposed_visits]

    this.x.domain([
      1,
      this._d3.max(allVisits, visitType => visitType.length)
    ])

    this.y.domain([
      this._d3.min(allVisits, visits => this._d3.min(visits, visit => visit.rate)),
      this._d3.max(allVisits, visits => this._d3.max(visits, visit => visit.rate))
    ])

    this.xAxis
    .transition()
    .duration(750)
    .call(this.xAxisScale)

    this.yAxis
    .transition()
    .duration(750)
    .call(this.yAxisScale)

    this.chart.selectAll('.line')
    .data(allVisits)
    .transition()
    .duration(750)
    .attr('d', d => this.line(d))

    const visits = this.chart.selectAll('.visits')
    .data(allVisits)
    .enter().append('g')
    .attr('class', 'visits')

    const _d3 = this._d3
    visits.append('path')
    .attr('class', (d, i) => `line ${this.visitTypes(i)}`)
    .attr('d', d => this.line(d))
    .attr('fill', 'none')
    .attr('stroke-dasharray', function () {
      const lineLength = _d3.select(this).node().getTotalLength()
      return `${lineLength} ${lineLength}`
    })
    .attr('stroke-dashoffset', function () {
      return _d3.select(this).node().getTotalLength()
    })
    .transition()
    .duration(1800)
    .attr('stroke-dashoffset', 0)
    .each('end', function () {
      this.removeAttribute('stroke-dasharray')
      this.removeAttribute('stroke-dashoffset')
    })
  }
}
